const Integrations = () => '/integrations';

export const RoutePaths = {
  Home: () => '/',
  Integrations,
  AuthenticateView: () => '/authenticate',
  FourZeroFourView: () => '/404',
  CallbackView: (integration_key = ':partner_id') => `/callback/${integration_key}`,
  ImportFieldsView: (config_id = ':config_id') => `/integrations/${config_id}/import-fields`,
  ImportOrganizationsView: (config_id = ':config_id') =>
    `/integrations/${config_id}/import-organizations`,
  ConfigurationViewV3: (config_id = ':config_id') =>
    `/integrations/v3/${config_id}/configuration-view`,
  ConfiguredIntegrationOverview: (config_id = ':config_id') => `/integrations/v3/${config_id}`,
  ConfigureIntegrationView: (config_id = ':config_id') => `/integrations/${config_id}`,
  FileUploadView: () => '/file-upload',
  ResourceMapperView: () => '/resource-mapper',
  FieldMatchingView: () => '/field-matching',
  ImportConfigurationDataRangeView: (config_id = ':config_id') =>
    `/integrations/${config_id}/import-data-range`,
  ImportDataRangeView: () => '/data-range',
  BasicAuthView: (partner_id = ':integration_key') => `/integrations/${partner_id}/basicauth`,
  SandboxRoute: () => '/sandbox',
  DemoMFE: () => '/demo-mfe',
  ConfigureIntegrationWizardView: (integration_key = ':integration_key') =>
    `/integrations/${integration_key}/configure-integration`,
  DefaultRoute: () => Integrations(),
};
